<template>
  <ul
    ref="menuNav"
    class="menu-nav menu-nav--compact"
    @click="handleMenuNavClick"
    @keydown="handleMenuNavKeydown"
  >
    <SidebarSearch />

    <router-link
      to="/dashboard"
      custom
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="fas fa-home mr-5 menu-icon"></i>
          <span class="menu-text">Beranda</span>
        </a>
      </li>
    </router-link>

    <router-link
      to="/my-appointment"
      custom
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="canViewMyAppointment"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="fas fa-tasks mr-5 menu-icon"></i>
          <span class="menu-text">Jadwal Saya</span>
        </a>
      </li>
    </router-link>

    <!-- <li class="menu-section" v-if="titleDoctorPatient"> -->
    <li
      class="menu-section"
      v-if="appointment || schedule || patient || doctor || clinic_queue || home_care || bed"
    >
      <h4 class="menu-text menu-title-color">Pelayanan Pasien</h4>
      <i class="menu-icon flaticon-more-v2 menu-icon"></i>
    </li>

    <SidebarMenuItem
      v-for="item in patientServiceMenus"
      :key="item.key"
      :item="item"
    />

    <template v-if="false">
    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      :class="{ 'menu-item-open': hasActiveChildren('/queue') }"
      v-if="clinic_queue"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="fas fa-ticket-alt menu-icon mr-5"></i
        ><span class="menu-text">Antrean Klinik</span><i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu">
        <span class="menu-arrow"></span>
        <ul class="menu-subnav">
          <router-link to="/user-managements/security-center" custom v-slot="{ href, navigate, isActive, isExactActive }" v-if="user_access">
            <li class="menu-item" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
              <a :href="href" class="menu-link" @click="navigate"><i class="menu-bullet menu-bullet-dot"><span></span></i><span class="menu-text">Pusat Keamanan</span></a>
            </li>
          </router-link>
          <router-link
            v-if="clinic_queue_dashboard"
            to="/queue"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            ><li
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate"
                ><i class="menu-bullet menu-bullet-dot"><span></span></i
                ><span class="menu-text">Dashboard Antrean</span></a
              >
            </li></router-link
          >
          <router-link
            v-if="clinic_queue_display"
            to="/queue/display"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            ><li
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate"
                ><i class="menu-bullet menu-bullet-dot"><span></span></i
                ><span class="menu-text">Display Antrean</span></a
              >
            </li></router-link
          >
          <router-link
            v-if="clinic_queue_settings"
            to="/queue/settings"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            ><li
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate"
                ><i class="menu-bullet menu-bullet-dot"><span></span></i
                ><span class="menu-text">Pengaturan Loket</span></a
              >
            </li></router-link
          >
          <router-link
            v-if="clinic_queue_report"
            to="/queue/report"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            ><li
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate"
                ><i class="menu-bullet menu-bullet-dot"><span></span></i
                ><span class="menu-text">Laporan Antrean</span></a
              >
            </li></router-link
          >
        </ul>
      </div>
    </li>

    <router-link
      to="/inpatient"
      custom
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="bed"
    >
      <li
        aria-haspopup="true"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="fas fa-hospital-user menu-icon mr-5"></i>
          <span class="menu-text">Rawat Inap</span>
        </a>
      </li>
    </router-link>

    <router-link to="/quality" custom v-slot="{ href, navigate, isActive }">
      <li
        aria-haspopup="true"
        class="menu-item"
        :class="{ 'menu-item-active': isActive }"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="fas fa-shield-alt menu-icon mr-5"></i>
          <span class="menu-text">Mutu & Keselamatan</span>
        </a>
      </li>
    </router-link>

    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{ 'menu-item-open': hasActiveChildren('/appointment') }"
      v-if="appointment"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="fas fa-clipboard-list menu-icon mr-5"></i>
        <span class="menu-text">Pendaftaran & Janji</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu">
        <span class="menu-arrow"></span>
        <ul class="menu-subnav">
          <router-link
            to="/appointment/list/0"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="appointment_list"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Semua Pendaftaran</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/appointment/add"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="appointment_add"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Pendaftaran Baru</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/appointment/todays"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="appointment_today"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Hari Ini</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/appointment/upcoming"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="appointment_upcoming"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Akan Datang</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/appointment/calendar"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="appointment_calendar"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Kalender Perjanjian</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/appointment/room-calendar"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="appointment_calendar"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Kalender Ruangan</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/masters/appointment-statuses/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="master_appointment_status"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Status Perjanjian</span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li>

    <router-link
      to="/schedule/list"
      custom
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="schedule && (schedule_list || schedule_holiday)"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
          hasActiveChildren('/schedule') && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="fas fa-calendar-alt menu-icon mr-5"></i>
          <span class="menu-text">Jadwal Dokter</span>
        </a>
      </li>
    </router-link>

    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{
        'menu-item-open': hasActiveChildren([
          'patient/list',
          'patient/cases',
          'patient/cases-print',
          'patient/documents',
          'prescriptions/list',
          'patient/themplate-print',
          'patient/distribution-map',
          'medical-checkup/list',
        ]),
      }"
      v-if="patient"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="fas fa-user-injured mr-5 menu-icon"></i>
        <span class="menu-text">Pasien</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu">
        <span class="menu-arrow"></span>
        <ul class="menu-subnav">
          <router-link
            to="/patient/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="patient_list"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link menu-icon" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Data Pasien</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/patient/cases"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="patient_case"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Rekam Medis</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/patient/themplate-print"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="patient_case_print"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Cetak Blanko Rekam Medis</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/patient/documents"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="patient_document"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Dokumen Pasien</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/prescriptions/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="prescription"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Resep Pasien</span>
              </a>
            </li>
          </router-link>

        </ul>
      </div>
    </li>

    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{ 'menu-item-open': hasActiveChildren('/doctor') }"
      v-if="doctor"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="fas fa-user-md mr-5 menu-icon"></i>
        <span class="menu-text">Dokter</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu">
        <span class="menu-arrow"></span>
        <ul class="menu-subnav">
          <router-link
            to="/doctor/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="false && doctor_list"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot menu-icon">
                  <span></span>
                </i>
                <span class="menu-text">Daftar Dokter</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/doctor/treatments"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="doctor_treatment"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot menu-icon">
                  <span class="sub-menu-icon"></span>
                </i>
                <span class="menu-text">Riwayat Pengobatan</span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li>

    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{ 'menu-item-open': hasActiveChildren('/bpjs') }"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="fas fa-id-card menu-icon mr-5"></i>
        <span class="menu-text">BPJS</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu">
        <span class="menu-arrow"></span>
        <ul class="menu-subnav">
          <router-link
            v-for="item in bpjsMenus"
            :key="item.to"
            :to="item.to"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              class="menu-item"
              :class="{
                'menu-item-active':
                  $route.path === '/finance' && $route.query.tab === item.tab,
              }"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">{{ item.label }}</span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li>

    </template>
    <!-- <li class="menu-section" v-if="titlePaymentHumanResource">
      <h4 class="menu-text menu-title-color">OPERASIONAL & SDM</h4>
      <i class="menu-icon flaticon-more-v2"></i>
    </li> -->

    <li class="menu-section" v-if="medical_action || lab || bed || blood_bank">
      <h4 class="menu-text menu-title-color">Layanan Klinis</h4>
      <i class="menu-icon flaticon-more-v2"></i>
    </li>

    <!-- <router-link
      to="/used-package-service"
      custom
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="human_resource_employee"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="fas fa-money-bill mr-5 menu-icon"></i>
          <span class="menu-text">Deposit Pemakaian Layanan</span>
        </a>
      </li>
    </router-link> -->

    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{
        'menu-item-open': hasActiveChildren('/custom-pages'),
      }"
      v-if="medical_action"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="fas fa-diagnoses mr-5 menu-icon"></i>
        <span class="menu-text">Tindakan Medis</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu menu-submenu-classic menu-submenu-right">
        <ul class="menu-subnav">
          <router-link
            v-for="item in medicalActionWorkspaceMenus"
            :key="item.to"
            :to="item.to"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="item.manage ? medical_action_add : medical_action_list"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">{{ item.label }}</span>
              </a>
            </li>
          </router-link>
          <!-- <router-link
            to="/medicine-packages/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="shortcut_obat_alkes"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Shortcut Obat dan Alkes </span>
              </a>
            </li>
          </router-link> -->
          <!-- <router-link
            to="/masters/action-types/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="master_action_type"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Jenis Tindakan</span>
              </a>
            </li>
          </router-link> -->
        </ul>
      </div>
    </li>

    <!-- <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{
        'menu-item-open': hasActiveChildren([
          '/lab-report',
          '/lab-procedure',
          '/masters/lab-template',
          '/masters/lab-categories/list',
        ]),
      }"
      v-if="lab"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="fas fa-flask mr-5 menu-icon"></i>
        <span class="menu-text"> Pemeriksaan Lab </span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu menu-submenu-classic menu-submenu-right">
        <ul class="menu-subnav">
          <router-link
            to="/lab-procedure/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="lab_procedure"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Daftar Harga Lab </span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/lab-report/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="lab_report_list"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Laporan Lab </span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/lab-report/add"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="lab_report_add"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Tambah Laporan Lab </span>
              </a>
            </li>
          </router-link>

        </ul>
      </div>
    </li> -->

    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{
        'menu-item-open': hasActiveChildren([
          '/lab-report-2',
          '/lab-procedure-2',
          '/masters/lab-templates/',
          '/masters/fields/',
          '/masters/lab-categories/',
        ]),
      }"
      v-if="lab"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="fas fa-flask mr-5 menu-icon"></i>
        <span class="menu-text"> Pemeriksaan Lab</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu menu-submenu-classic menu-submenu-right">
        <ul class="menu-subnav">
          <router-link
            to="/lab-report-2/operations"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="lab_operations"
          >
            <li aria-haspopup="true" class="menu-item" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Ringkasan & Proses Lab</span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/lab-procedure-2/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="lab_procedure"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Pemeriksaan & Tarif</span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/lab-report-2/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="lab_report_list"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Hasil Pemeriksaan</span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/lab-report-2/add"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="lab_report_add"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Input Hasil Pemeriksaan</span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/masters/fields"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="fields"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Parameter & Nilai Rujukan</span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/masters/lab-templates/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="lab_template"
          >
            <li aria-haspopup="true" class="menu-item" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Template Laporan</span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/masters/lab-categories/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="master_lab_category"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Kategori Lab</span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li>

    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{
        'menu-item-open': hasActiveChildren([
          '/masters/rooms/',
          '/masters/buildings/',
          '/beds/',
        ]),
      }"
      v-if="bed"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="fas fa-procedures mr-5 menu-icon"></i>
        <span class="menu-text"> Bed </span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu menu-submenu-classic menu-submenu-right">
        <ul class="menu-subnav">
          <router-link
            to="/beds/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="bed_list"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Daftar Bed </span>
              </a>
            </li>
          </router-link>
          <!-- <router-link
            to="/beds/add"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="bed_add"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Tambah Bed </span>
              </a>
            </li>
          </router-link> -->
          <router-link
            to="/beds/allotment"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="bed_allotment"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Pemakaian </span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/beds/category"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="bed_category"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Kategori </span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/masters/buildings/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="master_building"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Gedung</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/masters/rooms/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="master_room"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Ruangan</span>
              </a>
            </li>
          </router-link>

          <!-- <router-link
            to="/beds/add-allotment"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="bed_add_allotment"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Tambah Pemakai </span>
              </a>
            </li>
          </router-link> -->
          <!-- <router-link
            to="/beds/allotment-history"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Riwayat Pemakaian </span>
              </a>
            </li>
          </router-link> -->
        </ul>
      </div>
    </li>

    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{
        'menu-item-open': hasActiveChildren([
          '/blood-bank/',
          '/donors/',
          '/donor-recipients/',
        ]),
      }"
      v-if="blood_bank"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="fas fa-tint mr-5 menu-icon"></i>
        <span class="menu-text"> Bank Darah </span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu menu-submenu-classic menu-submenu-right">
        <ul class="menu-subnav">
          <router-link
            to="/blood-bank/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="blood_bank_list"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Ringkasan &amp; Stok </span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/donors/add"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="donor_add"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Darah Masuk </span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/donor-recipients/add"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="donor_recipient_add"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Darah Keluar </span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/blood-bank/history"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="blood_bank_list"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Riwayat Transaksi </span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/donors/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="donor_list"
          >
            <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Pendonor </span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li>

    <li class="menu-section" v-if="medicine || pharmacy">
      <h4 class="menu-text menu-title-color">Farmasi</h4>
      <i class="menu-icon flaticon-more-v2"></i>
    </li>

    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{
        'menu-item-open': hasActiveChildren([
          '/inventory/',
          '/medicine/',
          '/stock-opnames/',
          '/stock-opname-report/',
          '/purchase-orders-pharmacy/',
        ]),
      }"
      v-if="medicine"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="fas fa-pills menu-icon mr-5"></i>
        <span class="menu-text">Obat & Alat Kesehatan</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu menu-submenu-classic menu-submenu-right">
        <ul class="menu-subnav">
          <router-link
            to="/medicine/control-center"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="medicine_stock"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Pusat Kendali Farmasi</span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/medicine/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="medicine_list"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Daftar Obat dan Alkes</span>
              </a>
            </li>
          </router-link>
          <!-- <router-link
            to="/medicine/add"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="medicine_add"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Tambah Obat dan Alkes</span>
              </a>
            </li>
          </router-link> -->
          <router-link
            to="/medicine/maintain-stock"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="medicine_stock"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Kartu Stok </span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/stock-opnames"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="stock_opname"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Stock Opname </span>
              </a>
            </li>
          </router-link>
          <!-- <router-link
            to="/medicine/vendors/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="medicine_vendor"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Supplier</span>
              </a>
            </li>
          </router-link> -->
          <router-link
            to="/purchase-orders-pharmacy"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="pharmacy_po"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Purchase Order Farmasi</span>
              </a>
            </li>
          </router-link>
          <!-- <router-link
            to="/medicine/purchase-order"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="medicine_list"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Purchase Order </span>
              </a>
            </li>
          </router-link> -->
        </ul>
      </div>
    </li>

    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{
        'menu-item-open': hasActiveChildren('/custom-pages'),
      }"
      v-if="pharmacy"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="fas fa-mortar-pestle mr-5 menu-icon"></i>
        <span class="menu-text">Pelayanan Apotek</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu menu-submenu-classic menu-submenu-right">
        <ul class="menu-subnav">
          <router-link
            to="/pharmacy/sales"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="pharmacy_sales"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Daftar Penjualan </span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/pharmacy/cashier"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="pharmacy_cashier"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <!-- <span class="menu-text"> Tambah Penjualan </span> -->
                <span class="menu-text">Kasir Apotek</span>
              </a>
            </li>
          </router-link>
          <router-link to="/pharmacy/compounds" custom v-slot="{ href, navigate, isActive }" v-if="pharmacy">
            <li aria-haspopup="true" class="menu-item" :class="[isActive && 'menu-item-active']"><a :href="href" class="menu-link" @click="navigate"><i class="menu-bullet menu-bullet-dot"><span></span></i><span class="menu-text">Racikan</span></a></li>
          </router-link>
          <router-link to="/pharmacy/workflow" custom v-slot="{ href, navigate, isActive }" v-if="pharmacy">
            <li aria-haspopup="true" class="menu-item" :class="[isActive && 'menu-item-active']"><a :href="href" class="menu-link" @click="navigate"><i class="menu-bullet menu-bullet-dot"><span></span></i><span class="menu-text">Operasional Apotek</span></a></li>
          </router-link>
          <router-link to="/pharmacy/control-center" custom v-slot="{ href, navigate, isActive }" v-if="pharmacy">
            <li aria-haspopup="true" class="menu-item" :class="[isActive && 'menu-item-active']"><a :href="href" class="menu-link" @click="navigate"><i class="menu-bullet menu-bullet-dot"><span></span></i><span class="menu-text">Control Center</span></a></li>
          </router-link>
        </ul>
      </div>
    </li>
    <li class="menu-section" v-if="payment || human_resource_employee">
      <h4 class="menu-text menu-title-color">Kasir & Pendapatan</h4>
      <i class="menu-icon flaticon-more-v2"></i>
    </li>

    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{
        'menu-item-open': hasActiveChildren([
          'payment/list',
          'payment/add',
          'payment/edit',
          'payment/detail',
          'masters/payment-methods/list',
          'masters/banks/list',
        ]),
      }"
      v-if="payment"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="fas fa-money-bill-wave menu-icon mr-5"></i>
        <span class="menu-text">Pembayaran</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu">
        <span class="menu-arrow"></span>
        <ul class="menu-subnav">
          <router-link
            to="/payment/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="payment_list"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Invoice & Pembayaran</span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/payment/add"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="payment_add"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Buat Invoice</span>
              </a>
            </li>
          </router-link>
          <!-- <router-link
            to="/masters/payment-methods/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="master_payment_method"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Metode Pembayaran</span>
              </a>
            </li>
          </router-link> -->
          <router-link
            to="/masters/banks/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="master_payment_method"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Jenis Bank (EDC) </span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li>

    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{
        'menu-item-open': hasActiveChildren([
          '/payment-categories',
          '/masters/payment-category-types/list',
        ]),
      }"
      v-if="tenantConfig.subscribe_package_id != 4"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="fas fa-shopping-basket menu-icon mr-5"></i>
        <span class="menu-text">Produk Layanan</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu">
        <span class="menu-arrow"></span>
        <ul class="menu-subnav">
          <router-link
            to="/payment-categories/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="human_resource_employee"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Daftar Layanan</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/payment-categories/add"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="human_resource_employee"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Tambah Layanan</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/masters/payment-category-types/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="master_payment_category_type"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Tipe Produk Layanan</span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li>

    <router-link
      to="/used-package-service"
      custom
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="
        human_resource_employee == true &&
        tenantConfig.subscribe_package_id != 4
      "
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="fas fa-money-bill mr-5 menu-icon"></i>
          <span class="menu-text">Deposit Pemakaian Layanan</span>
        </a>
      </li>
    </router-link>

    <li class="menu-section" v-if="medicine || medicine_stock">
      <h4 class="menu-text menu-title-color">Inventori Umum</h4>
      <i class="menu-icon flaticon-more-v2"></i>
    </li>

    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{
        'menu-item-open': hasActiveChildren([
          '/inventory/list',
          '/inventory/add',
        ]),
      }"
      v-if="medicine"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="fas fa-pallet menu-icon mr-5"></i>
        <span class="menu-text">Data Inventori</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu menu-submenu-classic menu-submenu-right">
        <ul class="menu-subnav">
          <router-link
            to="/inventory/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="medicine_list"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Daftar Item</span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/inventory/add"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="medicine_add"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Tambah Item</span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li>

    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{
        'menu-item-open': hasActiveChildren(['/inventory/']),
      }"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="fas fa-boxes menu-icon mr-5"></i>
        <span class="menu-text">Kontrol Stok</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu menu-submenu-classic menu-submenu-right">
        <ul class="menu-subnav">
          <router-link
            to="/inventory/maintain-stock"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="medicine_stock"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Kartu Stok </span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/inventory/stock-opname"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="stock_opname"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Stock Opname </span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/inventory/stock-opname-report"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="stock_opname"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Laporan Stock Opname </span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li>

    <router-link
      to="/inventory/master-data"
      custom
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="medicine"
    >
      <li
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="fas fa-database mr-5 menu-icon"></i>
          <span class="menu-text">Master Data</span>
        </a>
      </li>
    </router-link>

    <router-link
      to="/inventory/category"
      custom
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="false && medicine"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="fas fa-table mr-5 menu-icon"></i>
          <span class="menu-text">Kategori</span>
        </a>
      </li>
    </router-link>

    <router-link
      to="/inventory/purchase-order"
      custom
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="medicine"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="fas fa-file-alt mr-5 menu-icon"></i>
          <span class="menu-text">Purchase Order (PO)</span>
        </a>
      </li>
    </router-link>

    <router-link
      to="/masters/warehouses/list"
      custom
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="false && medicine"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="fas fa-warehouse mr-5 menu-icon"></i>
          <span class="menu-text">Gudang</span>
        </a>
      </li>
    </router-link>

    <router-link
      to="/masters/uoms/list"
      custom
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="false && medicine"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="fas fa-balance-scale mr-5 menu-icon"></i>
          <span class="menu-text">Satuan</span>
        </a>
      </li>
    </router-link>

    <router-link
      to="/medicine/vendors/list"
      custom
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="false && medicine"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="fas fa-truck-loading mr-5 menu-icon"></i>
          <span class="menu-text">Supplier</span>
        </a>
      </li>
    </router-link>

    <li class="menu-section" v-if="titleMarketing">
      <h4 class="menu-text menu-title-color">Customer Relationship (CRM)</h4>
      <i class="menu-icon flaticon-more-v2 menu-icon"></i>
    </li>

    <router-link
      to="/crm/list"
      custom
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="marketing_crm"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="fas fa-birthday-cake mr-5 menu-icon"></i>
          <span class="menu-text">Pasien Ulang Tahun</span>
        </a>
      </li>
    </router-link>

    <router-link
      to="/crm/list-recently"
      custom
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="marketing_crm && tenantConfig.subscribe_package_id != 4"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="fas fa-calendar-alt mr-5 menu-icon"></i>
          <span class="menu-text">Kunjungan Terbaru</span>
        </a>
      </li>
    </router-link>

    <router-link
      to="/crm/list-deposit"
      custom
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="marketing_crm && tenantConfig.subscribe_package_id != 4"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="fas fa-wallet mr-5 menu-icon"></i>
          <span class="menu-text">Pengingat Deposit</span>
        </a>
      </li>
    </router-link>

    <!-- <router-link
      to="/crm/broadcast-campaigns"
      custom
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="human_resource_employee"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="fas fa-calendar-alt mr-5 menu-icon"></i>
          <span class="menu-text">Pesan Siaran (Broadcast Campaign)</span>
        </a>
      </li>
    </router-link> -->

    <router-link
      to="/crm/patient-spending-money"
      custom
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="marketing_crm && tenantConfig.subscribe_package_id != 4"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="fas fa-crown mr-5 menu-icon"></i>
          <!-- <i class="fas fa-calendar-alt mr-5 menu-icon"></i> -->
          <span class="menu-text">Pasien Loyal</span>
        </a>
      </li>
    </router-link>

    <router-link
      to="/masters/coupons/list"
      custom
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="marketing_view"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="fas fa-percent menu-icon mr-5"></i>
          <span class="menu-text">Kupon </span>
        </a>
      </li>
    </router-link>
    <router-link
      to="/masters/promos/list"
      custom
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="marketing_view"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="fas fa-tags menu-icon mr-5"></i>
          <span class="menu-text">Diskon & Promo </span>
        </a>
      </li>
    </router-link>
    <router-link
      to="/efectivity-dashboard"
      custom
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="marketing_view"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="fas fa-chart-bar mr-5 menu-icon"></i>
          <span class="menu-text">Dashboard Pemasaran & Loyalitas</span>
        </a>
      </li>
    </router-link>

    <li
      class="menu-section"
      v-if="payment || master_bank_account || human_resource || polyclinic"
    >
      <h4 class="menu-text menu-title-color">SDM & Keuangan</h4>
      <i class="menu-icon flaticon-more-v2"></i>
    </li>

    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      :class="{ 'menu-item-open': hasActiveChildren(['/finance']) }"
      v-if="payment"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="fas fa-chart-pie menu-icon mr-5"></i>
        <span class="menu-text">Finance Center</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu">
        <span class="menu-arrow"></span>
        <ul class="menu-subnav">
          <router-link
            v-for="item in financeMenuItems.filter(entry => (!entry.guarantor || guarantor) && (!entry.homeCare || home_care_report))"
            :key="item.tab || item.path"
            :to="item.path || { path: '/finance', query: { tab: item.tab } }"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              class="menu-item"
              :class="{
                'menu-item-active': item.path
                  ? $route.path.indexOf(item.path) === 0
                  : $route.path === '/finance' && $route.query.tab === item.tab,
              }"
            >
              <a :href="href" class="menu-link" @click="navigate"
                ><i class="menu-bullet menu-bullet-dot"><span></span></i
                ><span class="menu-text">{{ item.label }}</span></a
              >
            </li>
          </router-link>
        </ul>
      </div>
    </li>

    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{
        'menu-item-open': hasActiveChildren([
          'expense-categories/list',
          'expense-categories/add',
          'expense-categories/edit',
          'expense-categories/detail',
          'expense/list',
          'expense/add',
          'expense/edit',
          'expense/detail',
        ]),
      }"
      v-if="false && payment"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="fas fa-money-bill-wave menu-icon mr-5"></i>
        <span class="menu-text">Pengeluaran</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu">
        <span class="menu-arrow"></span>
        <ul class="menu-subnav">
          <router-link
            to="/expense/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="expense_list"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Daftar Pengeluaran</span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/expense-categories/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="expense_category"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Kategori Pengeluaran</span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li>

    <router-link
      to="/masters/bank-accounts/list"
      custom
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="false && master_bank_account"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="fas fa-money-check-alt mr-5 menu-icon"></i>
          <span class="menu-text">Rekening Bank</span>
        </a>
      </li>
    </router-link>

    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{
        'menu-item-open': hasActiveChildren('/custom-error/error'),
      }"
      v-if="human_resource"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="fas fa-user-nurse menu-icon mr-5"></i>
        <span class="menu-text">Manajemen SDM</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu">
        <span class="menu-arrow"></span>
        <ul class="menu-subnav">
          <router-link
            to="/human-resource/doctor-center"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="doctor_list"
          >
            <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item" :class="[isActive && 'menu-item-active',isExactActive && 'menu-item-active']">
              <a :href="href" class="menu-link" @click="navigate"><i class="menu-bullet menu-bullet-dot"><span></span></i><span class="menu-text">Dokter & Komisi</span></a>
            </li>
          </router-link>
          <router-link
            to="/doctor/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="false && doctor_list"
          >
            <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item" :class="[isActive && 'menu-item-active',isExactActive && 'menu-item-active']">
              <a :href="href" class="menu-link" @click="navigate"><i class="menu-bullet menu-bullet-dot"><span></span></i><span class="menu-text">Daftar Dokter</span></a>
            </li>
          </router-link>
          <router-link
            to="/human-resource/workforce-center"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="
              human_resource_employee ||
                payroll_list ||
                remuneration ||
                master_department ||
                master_position
            "
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Workforce & Payroll</span>
              </a>
            </li>
          </router-link>
          <!-- Legacy SDM routes stay available for compatibility, but all
               operational entry points now live inside Workforce & Payroll. -->
          <template v-if="false">
          <router-link
            to="/human-resource/employee"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="human_resource_employee"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Karyawan</span>
              </a>
            </li>
          </router-link>
          </template>
          <router-link
            to="/human-resource/attendance"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="human_resource_employee"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Absensi</span>
              </a>
            </li>
          </router-link>
          <template v-if="false">
          <router-link
            to="/human-resource/attendance/report"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="human_resource_employee"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Rekap Absensi</span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/masters/remunerations/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="remuneration"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Remunerasi</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/masters/remuneration-types/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="remuneration"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Tipe Remunerasi</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/masters/departemens/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="master_department"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Departemen</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/masters/positions/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="master_position"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Jabatan</span>
              </a>
            </li>
          </router-link>
          </template>
        </ul>
      </div>
    </li>

    <router-link
      to="/polyclinic"
      custom
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="polyclinic"
    >
      <li
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="fas fa-heartbeat mr-5 menu-icon"></i>
          <span class="menu-text">Poliklinik</span>
        </a>
      </li>
    </router-link>

    <!-- <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{
        'menu-item-open': hasActiveChildren([
          'payment-category/list',
          'payment-category/add',
          'payment-category/edit',
          'payment-category/detail',
          'journal-reports',
          'coas/list',
          'coas/add',
          'coas/detail',
          'coas/edit',
          '/purchase-orders/list',
          '/purchase-orders/add',
          '/purchase-orders/edit',
          '/purchase-orders/detail',
        ]),
      }"
      v-if="payment"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="fas fa-money-bill-wave menu-icon mr-5"></i>
        <span class="menu-text">Pengeluaran</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu">
        <span class="menu-arrow"></span>
        <ul class="menu-subnav">
          <router-link
            to="/payment/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="payment_list"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Pembayaran</span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/payment/add"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="payment_add"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Tambah Pembayaran</span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/expense/add"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="expense_add"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Tambah Pengeluaran</span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/purchase-orders/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="payment_po"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Purchase Order (PO) Klinik</span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/coas/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="coa"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">COA</span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li> -->

    <template v-if="report || eksekutif_dashboard">
      <li class="menu-section">
        <h4 class="menu-text menu-title-color">Laporan & Analitik</h4>
        <i class="menu-icon flaticon-more-v2"></i>
      </li>

      <SidebarMenuItem
        v-for="item in reportAnalysisMenus"
        :key="item.key"
        :item="item"
      />
    </template>

    <!-- <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{
        'menu-item-open': hasActiveChildren('/custom-error/error'),
      }"
      v-if="report"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="fas fa-file mr-5 menu-icon"></i>
        <span class="menu-text">Laporan Komisi</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu">
        <span class="menu-arrow"></span>
        <ul class="menu-subnav">
          <router-link
            to="/report/doctor-commision"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="report_doctor_commision"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Komisi Dokter</span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/report/doctor-commision"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="report_doctor_commision"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Komisi Karyawan</span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/journal-reports/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="journal_report_list"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Buku Jurnal</span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/human-resource/workforce-center?tab=reports"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="payroll_report_list"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Penggajian</span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li> -->

    <li
      class="menu-section"
      v-if="branch_network || user_management || configuration || titleWebsite"
    >
      <h4 class="menu-text menu-title-color">Administrasi</h4>
      <i class="menu-icon flaticon-more-v2"></i>
    </li>

    <router-link to="/branch-network" custom v-slot="{ href, navigate, isActive, isExactActive }" v-if="branch_network">
      <li class="menu-item" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
        <a :href="href" class="menu-link" @click="navigate"><i class="fas fa-clinic-medical mr-5 menu-icon"></i><span class="menu-text">Jaringan & Multi-Cabang</span></a>
      </li>
    </router-link>

    <router-link to="/product-settings" custom v-slot="{ href, navigate, isActive, isExactActive }" v-if="vertical_settings">
      <li class="menu-item" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
        <a :href="href" class="menu-link" @click="navigate"><i class="fas fa-layer-group mr-5 menu-icon"></i><span class="menu-text">Profil Produk Klinik</span></a>
      </li>
    </router-link>

    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{
        'menu-item-open': hasActiveChildren('/user-managements'),
      }"
      v-if="user_management"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="fas fa-user-cog mr-5 menu-icon"></i>
        <span class="menu-text"> Manajemen Pengguna </span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu menu-submenu-classic menu-submenu-right">
        <ul class="menu-subnav">
          <router-link
            to="/user-managements/security-center"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="user_access"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Pengguna & Cabang </span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/user-managements/position-access"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="position_access"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Akses Bawaan Jabatan </span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/user-managements/user-access"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="user_access"
          >
            <li class="menu-item" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Hak Akses Khusus</span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li>

    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{
        'menu-item-open': hasActiveChildren('/blankboard'),
      }"
      v-if="user_management"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="fas fa-scroll mr-5 menu-icon"></i>
        <span class="menu-text"> Pengumuman </span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu menu-submenu-classic menu-submenu-right">
        <ul class="menu-subnav">
          <router-link
            to="/announcements/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="announcement"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Daftar Pengumuman </span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/masters/announcement-categories/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="master_announcement_category"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Kategori Pengumuman</span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li>

    <!-- <li class="menu-section" v-if="titleOperational">
      <h4 class="menu-text menu-title-color">Operasional Pendukung</h4>
      <i class="menu-icon flaticon-more-v2"></i>
    </li> -->

    <!-- <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{
        'menu-item-open': hasActiveChildren('/purchase-orders'),
      }"
      v-if="medicine"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="fas fa-mortar-pestle mr-5 menu-icon"></i>
        <span class="menu-text"> PO Apotek </span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu menu-submenu-classic menu-submenu-right">
        <ul class="menu-subnav">
          <router-link
            to="/purchase/orders"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="pharmacy"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Daftar PO </span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li> -->

    <!-- <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{
        'menu-item-open': hasActiveChildren('/custom-pages'),
      }"
      v-if="pharmacy"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="fas fa-mortar-pestle mr-5 menu-icon"></i>
        <span class="menu-text"> Apotek </span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu menu-submenu-classic menu-submenu-right">
        <ul class="menu-subnav">
          <router-link
            to="/pharmacy/dashboard"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="pharmacy_dashboard"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Dashboard </span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/pharmacy/sales"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="pharmacy_sales"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Penjualan </span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/pharmacy/cashier"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="pharmacy_cashier"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Tambah Penjualan </span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/help"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="pharmacy_report"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Laporan </span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li> -->

    <!-- <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{
        'menu-item-open': hasActiveChildren('/medicine'),
      }"
      v-if="system_online_shop"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="fas fa-shopping-cart menu-icon mr-5"></i>
        <span class="menu-text"> Toko Online </span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu menu-submenu-classic menu-submenu-right">
        <ul class="menu-subnav">
          <router-link
            to="/order/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="online_shop"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Daftar Pesanan</span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li> -->

    <!-- <li class="menu-section" v-if="titleReportAnalysis">
      <h4 class="menu-text menu-title-color">Laporan & Analisis</h4>
      <i class="menu-icon flaticon-more-v2"></i>
    </li> -->

    <!-- <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{
        'menu-item-open': hasActiveChildren('/custom-error/error'),
      }"
      v-if="report"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="fas fa-file mr-5 menu-icon"></i>
        <span class="menu-text">Laporan</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu">
        <span class="menu-arrow"></span>
        <ul class="menu-subnav">
          <router-link
            to="/journal-reports/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="journal_report_list"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Buku Jurnal</span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/human-resource/workforce-center?tab=reports"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="payroll_report_list"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Penggajian</span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li> -->

    <!-- <router-link
      to="/builder"
      custom
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="data_analysis"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="fas fa-chart-bar mr-5 menu-icon"></i>
          <span class="menu-text">Analisis Data</span>
        </a>
      </li>
    </router-link> -->

    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{
        'menu-item-open menu-item-active': hasActiveChildren('/website'),
      }"
      v-if="cms"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="fas fa-globe mr-5 menu-icon"></i>
        <span class="menu-text">Website &amp; CMS</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu">
        <span class="menu-arrow"></span>
        <ul class="menu-subnav">
          <router-link
            to="/website/setting"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="website_setting"
          >
            <li
              aria-haspopup="true"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Setelan Website</span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/website/slide"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="website_slide"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Slide Banner</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/website/service"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="website_service"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Layanan</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/website/posts"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="website_post"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Berita</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/website/post-category"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="website_post_category"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Kategori Berita</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/website/doctor"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="website_doctor"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Dokter Spesialis</span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li>

    <!-- <li class="menu-section" v-if="titleEtc"> -->
    <!-- <li class="menu-section" v-if="titleEtc">
      <h4 class="menu-text menu-title-color">Lain-Lain</h4>
      <i class="menu-icon flaticon-more-v2 menu-icon"></i>
    </li> -->

    <!-- <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{
        'menu-item-open': hasActiveChildren('/masters'),
      }"
      v-if="master"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="fas fa-box mr-5 menu-icon"></i>
        <span class="menu-text"> Master Data</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu menu-submenu-classic menu-submenu-right">
        <ul class="menu-subnav">

          <router-link
            to="/masters/payment-category-types/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="master_payment_category_type"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Tipe Produk Layanan</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/masters/coa-categories/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="master_coa_category"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Kategori COA</span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/masters/sub-ledgers/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="master_sub_ledger"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Sub Ledger</span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/masters/cash-flows/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="master_cash_flow"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Cash Flow</span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li> -->

    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{
        'menu-item-open': hasActiveChildren('/settings') || hasActiveChildren('/system'),
      }"
      v-if="configuration || audit_log"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="fas fa-cogs mr-5 menu-icon"></i>
        <span class="menu-text"> Sistem </span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu menu-submenu-classic menu-submenu-right">
        <ul class="menu-subnav">
          <router-link
            to="/system/audit-logs"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="audit_log"
          >
            <li class="menu-item" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Log Audit</span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/settings/edit"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Konfigurasi </span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/system/integrations/whatsapp"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="configuration"
          >
            <li class="menu-item" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Integrasi WhatsApp</span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/settings/quick-access"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Akses Cepat </span>
              </a>
            </li>
          </router-link>
          <!-- <router-link
            to="/help"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Atur Sistem </span>
              </a>
            </li>
          </router-link> -->
          <!-- <router-link
            to="/custom-pages/profile"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Payment Gateway </span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/custom-pages/profile"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Impor </span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/custom-pages/profile"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Backup Database </span>
              </a>
            </li>
          </router-link> -->
        </ul>
      </div>
    </li>

    <router-link
      to="/profile"
      custom
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="false && profile"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="fas fa-user mr-5 menu-icon"></i>
          <span class="menu-text">Profile</span>
        </a>
      </li>
    </router-link>

    <!-- <router-link
      to="/help"
      custom
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="fas fa-question-circle mr-5 menu-icon"></i>
          <span class="menu-text">Bantuan</span>
        </a>
      </li>
    </router-link> -->
    <li
      v-if="false"
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{
        'menu-item-open': hasActiveChildren(['/guide', '/help']),
      }"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="fas fa-cogs mr-5 menu-icon"></i>
        <span class="menu-text"> Bantuan </span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu menu-submenu-classic menu-submenu-right">
        <ul class="menu-subnav">
          <router-link
            to="/guide"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Tutorial </span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/help"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Kontak </span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li>

    <li class="menu-section" v-if="satu_sehat_menu">
      <h4 class="menu-text menu-title-color">Integrasi SATUSEHAT</h4>
      <i class="menu-icon flaticon-more-v2"></i>
    </li>
    <router-link
      to="/satu-sehat/posting"
      custom
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="satu_sehat_posting"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="fas fa-file-medical mr-5 menu-icon"></i>
          <span class="menu-text">Kirim Data Klinis</span>
        </a>
      </li>
    </router-link>
    <router-link
      to="/satu-sehat/dashboard"
      custom
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="satu_sehat_dashboard"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="fas fa-file-medical mr-5 menu-icon"></i>
          <span class="menu-text">Dashboard</span>
        </a>
      </li>
    </router-link>
    <router-link
      to="/satu-sehat/access-token"
      custom
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="satu_sehat_api"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="fas fa-file-medical mr-5 menu-icon"></i>
          <span class="menu-text">Kode Akses API</span>
        </a>
      </li>
    </router-link>

    <li class="menu-section">
      <h4 class="menu-text menu-title-color">Akun & Langganan</h4>
      <i class="menu-icon flaticon-more-v2"></i>
    </li>

    <router-link
      to="/profile"
      custom
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="profile"
    >
      <li
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="fas fa-user mr-5 menu-icon"></i>
          <span class="menu-text">Profil Saya</span>
        </a>
      </li>
    </router-link>

    <SidebarMenuItem :item="helpMenu" />

    <router-link
      to="/info-clinic"
      custom
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="fas fa-info-circle mr-5 menu-icon"></i>
          <span class="menu-text">Info Klinik</span>
        </a>
      </li>
    </router-link>

    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{
        'menu-item-open': hasActiveChildren('/subscribe'),
      }"
    >
      <a href="#" class="menu-link menu-toggle">
        <!-- <i class="fas fa-user-cog mr-5 menu-icon"></i> -->
        <i class="fas fa-handshake mr-5 menu-icon"></i>
        <span class="menu-text"> Berlangganan</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu menu-submenu-classic menu-submenu-right">
        <ul class="menu-subnav">
          <router-link
            to="/billings/list"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="user_access"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Invoice </span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/subscribe/package"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-if="position_access"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Berlangganan</span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li>

    <router-link
      to="/trust-center"
      custom
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        class="menu-item menu-item-persistent trust-center-menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="fas fa-shield-alt mr-5 menu-icon"></i>
          <span class="menu-text">Trust Center</span>
        </a>
      </li>
    </router-link>
  </ul>
</template>

<script>
import { mapGetters } from "vuex";
import module from "@/core/modules/CrudModule.js";
import ApiService from "@/core/services/api.service.js";
import { getTenantConfig } from "@/core/services/jwt.service.js";
import SidebarMenuItem from "@/view/layout/aside/SidebarMenuItem.vue";
import SidebarSearch from "@/view/layout/aside/SidebarSearch.vue";
import ProductConfigurationService from "@/core/services/product-configuration.service.js";

export default {
  name: "KTMenu",
  components: { SidebarMenuItem, SidebarSearch },
  data() {
    return {
      productConfiguration: ProductConfigurationService.current(),
      medicalActionWorkspaceMenus: [
        { to: "/medical-actions/dashboard", label: "Ringkasan", manage: false },
        { to: "/medical-actions/requests", label: "Worklist Tindakan", manage: true },
        { to: "/medical-actions/list", label: "Riwayat Tindakan", manage: false },
        { to: "/medical-actions/audit", label: "Pelaporan & Integrasi", manage: false },
      ],
      financeMenuItems: [
        { tab: "dashboard", label: "Dashboard Keuangan" },
        { path: "/guarantors", label: "Penjamin & Piutang", guarantor: true },
        { path: "/finance?tab=reports&report=cost-center-profitability&cost_center=HC&service_channel=home_care", label: "Profitabilitas Home Care", homeCare: true },
        { tab: "cash", label: "Pemasukan & Pengeluaran" },
        { path: "/masters/bank-accounts/list", label: "Rekening Bank" },
        { tab: "receivables", label: "Piutang" },
        { tab: "payables", label: "Utang Vendor" },
        { tab: "journals", label: "Akuntansi & Buku Besar" },
        { tab: "assets", label: "Aset Tetap" },
        { tab: "budgets", label: "Anggaran" },
        { tab: "reports", label: "Laporan Keuangan" },
      ],
      dashboard: false,
      polyclinic: false,
      my_appointment: false,
      eksekutif_dashboard: false,
      // doctor
      titleDoctorPatient: false,
      titleMarketing: false,
      marketing_crm: false,
      marketing_view: false,
      doctor: false,
      doctor_list: false,
      doctor_treatment: false,
      // schedule
      schedule: false,
      schedule_list: false,
      schedule_holiday: false,
      // patient
      patient: false,
      patient_list: false,
      patient_case: false,
      patient_case_print: false,
      patient_document: false,
      // appointment
      appointment: false,
      appointment_list: false,
      appointment_add: false,
      appointment_today: false,
      appointment_upcoming: false,
      appointment_calendar: false,
      clinic_queue: false,
      clinic_queue_dashboard: false,
      clinic_queue_display: false,
      clinic_queue_settings: false,
      clinic_queue_report: false,
      home_care: false,
      home_care_manage: false,
      home_care_clinical: false,
      home_care_report: false,
      home_care_settings: false,
      bpjs: false,
      bpjs_settings: false,
      quality: false,
      guarantor: false,
      clinical_documents: false,
      // payment
      titlePaymentHumanResource: false,
      payment: false,
      payment_list: false,
      payment_add: false,
      payment_category: false,
      expense_list: false,
      expense_add: false,
      expense_category: false,
      coa: false,
      payment_po: false,
      // human resource
      human_resource: false,
      human_resource_employee: false,
      payroll_list: false,
      remuneration: false,
      // operational
      titleOperational: false,
      // prescription
      prescription: false,
      // medicine
      medicine: false,
      medicine_list: false,
      medicine_add: false,
      medicine_category: false,
      medicine_stock: false,
      medicine_vendor: false,
      stock_opname: false,
      // lab
      lab: false,
      lab_procedure: false,
      lab_report_list: false,
      lab_report_add: false,
      lab_template: false,
      lab_operations: false,
      fields: false,
      // medical action
      medical_action: false,
      medical_action_list: false,
      medical_action_add: false,
      // bed
      bed: false,
      bed_list: false,
      bed_add: false,
      bed_category: false,
      bed_allotment: false,
      bed_add_allotment: false,
      // donor
      blood_bank: false,
      blood_bank_list: false,
      donor_list: false,
      donor_add: false,
      donor_recipient: false,
      donor_recipient_add: false,
      // pharmacy
      titlePharmacy: false,
      pharmacy: false,
      pharmacy_dashboard: false,
      pharmacy_sales: false,
      pharmacy_cashier: false,
      pharmacy_compounds: false,
      pharmacy_workflow: false,
      pharmacy_control_center: false,
      pharmacy_expense_list: false,
      pharmacy_expense_add: false,
      pharmacy_expense_category_list: false,
      pharmacy_report: false,
      pharmacy_po: false,
      // announcement
      announcement: false,
      // report
      titleReportAnalysis: false,
      report: false,
      report_payment_report: false,
      report_doctor_commision: false,
      report_expense_report: false,
      report_pharmacy_report: false,
      report_pharmacy_expense_report: false,
      journal_report_list: false,
      payroll_report_list: false,
      stock_opname_report_list: false,
      // data analysisi
      data_analysis: false,
      // setting
      titleWebsite: false,
      setting: false,
      // website
      cms: false,
      website_setting: false,
      website_service: false,
      website_slide: false,
      website_doctor: false,
      website_post: false,
      website_post_category: false,
      // master
      titleEtc: false,
      master: false,
      master_appointment_status: false,
      master_uom: false,
      master_action_type: false,
      master_lab_category: false,
      master_building: false,
      master_room: false,
      master_payment_method: false,
      master_payment_category_type: false,
      master_department: false,
      master_position: false,
      master_remuneration: false,
      master_announcement_category: false,
      master_announcement: false,
      master_coa_category: false,
      master_sub_ledger: false,
      master_cash_flow: false,
      master_bank_account: false,
      master_warehouse: false,
      // setelan sistem
      system_setting: false,
      system: false,
      setting_system: false,
      // user management
      user_management: false,
      user_access: false,
      position_access: false,
      audit_log: false,
      branch_network: false,
      vertical_settings: false,
      // profile
      profile: false,
      help: false,
      // online shop
      online_shop: false,
      system_online_shop: false,
      // shortcut obat dan alkes
      shortcut_obat_alkes: false,
      // rekapitulasi tindakan perbulan
      recap_action_report: false,
      recap_action_report_list: false,
      recap_action_report_manipulate: false,
      // Satu sehat
      satu_sehat_menu: false,
      satu_sehat_api: false,
      satu_sehat_posting: false,
      satu_sehat_dashboard: false,
      // settings
      configuration: false,
      // package
      tenantConfig: getTenantConfig(),
      bpjsMenus: [
        {
          label: "Pusat Integrasi",
          to: "/bpjs/integration-center",
          icon: "fas fa-network-wired",
        },
        {
          label: "Verifikasi Peserta",
          to: "/bpjs/peserta",
          icon: "fas fa-id-card",
        },
        {
          label: "Antrean JKN",
          to: "/bpjs/antrean",
          icon: "fas fa-list-ol",
        },
        {
          label: "Kunjungan PCare",
          to: "/bpjs/kunjungan",
          icon: "fas fa-notes-medical",
        },
        {
          label: "Rujukan",
          to: "/bpjs/rujukan",
          icon: "fas fa-share-square",
        },
        {
          label: "Pengaturan Integrasi",
          to: "/bpjs/pengaturan",
          icon: "fas fa-cog",
        },
      ],
    };
  },
  methods: {
    getMenuSectionItems(section) {
      const items = [];
      let sibling = section.nextElementSibling;

      while (
        sibling &&
        !sibling.classList.contains("menu-section") &&
        !sibling.classList.contains("menu-item-persistent")
      ) {
        items.push(sibling);
        sibling = sibling.nextElementSibling;
      }

      return items;
    },

    setMenuSectionExpanded(section, expanded) {
      section.classList.toggle("menu-section-open", expanded);
      section.setAttribute("aria-expanded", String(expanded));
      this.getMenuSectionItems(section).forEach((item) => {
        item.hidden = !expanded;
      });
    },

    initializeMenuSections(resetSelection = false) {
      const nav = this.$refs.menuNav;
      if (!nav) return;

      const sections = Array.from(nav.children).filter((item) =>
        item.classList.contains("menu-section")
      );
      if (!sections.length) return;

      sections.forEach((section) => {
        section.setAttribute("role", "button");
        section.setAttribute("tabindex", "0");
      });

      const activeSection = sections.find((section) =>
        this.getMenuSectionItems(section).some(
          (item) =>
            item.classList.contains("menu-item-active") ||
            Boolean(item.querySelector(".menu-item-active"))
        )
      );
      const currentSection = resetSelection
        ? null
        : sections.find((section) => section.classList.contains("menu-section-open"));
      const selectedSection = activeSection || currentSection || sections[0];

      sections.forEach((section) => {
        this.setMenuSectionExpanded(section, section === selectedSection);
      });
    },

    toggleMenuSection(section) {
      const shouldExpand = !section.classList.contains("menu-section-open");
      const sections = Array.from(this.$refs.menuNav.children).filter((item) =>
        item.classList.contains("menu-section")
      );

      sections.forEach((item) => {
        this.setMenuSectionExpanded(item, shouldExpand && item === section);
      });
    },

    handleMenuNavClick(event) {
      const section = event.target.closest(".menu-section");
      if (!section || section.parentElement !== this.$refs.menuNav) return;
      this.toggleMenuSection(section);
    },

    handleMenuNavKeydown(event) {
      if (event.key !== "Enter" && event.key !== " ") return;
      const section = event.target.closest(".menu-section");
      if (!section || section.parentElement !== this.$refs.menuNav) return;
      event.preventDefault();
      this.toggleMenuSection(section);
    },

    hasActiveChildren(match) {
      if (match.constructor === Array) {
        for (let i = 0; i < match.length; i++) {
          if (this.$route["path"].indexOf(match[i]) !== -1) {
            return true;
          }
        }
      } else {
        return this.$route["path"].indexOf(match) !== -1;
      }
    },

    getAccessRight() {
      ApiService.get("users/me").then((data) => {
        if (!data || !data.data || !data.data.data) return;
        const userData = data.data.data;
        ApiService.get("users/" + userData.user_id).then((response) => {
          if (!response || !response.data || !response.data.meta) return;
          if (data.data.data.position_id) {
            ApiService.get("positions/" + data.data.data.position_id).then(
              (result) => {
                let access_right = response.data.meta.access_right_display;
                let position_right = result.data.meta.access_right_display;

                // A user can receive permissions directly (or via a role) in
                // addition to the permissions inherited from their position.
                // Render from the merged set as well as caching it; rendering
                // only `position_right` made newly granted modules disappear
                // from the sidebar for owners who also have a position.
                let merge = [...new Set([...access_right, ...position_right])];

                window.localStorage.setItem(
                  "access_right_display",
                  JSON.stringify(merge)
                );

                this.setActiveMenu(merge);
              }
            );
          } else if (!data.data.data.position_id) {
            // let user = data.data.data
            // access_right = response.data.meta.access_right
            // user.access_right = response.data.meta.access_right

            // console.log("doctor access", response)

            this.setActiveMenu(response.data.meta.access_right_display);
            window.localStorage.setItem(
              "access_right_display",
              JSON.stringify(response.data.meta.access_right_display)
            );
          }
        });
      });
    },

    async setActiveMenu(accessParams = "") {
      let access_right;
      if (accessParams == "") {
        let access_right_user = window.localStorage.getItem(
          "access_right_display"
        );
        access_right = JSON.parse(access_right_user);
      } else if (accessParams != "") {
        access_right = accessParams;
      }

      let user_type = window.localStorage.getItem("user");
      let user_type_arr = JSON.parse(user_type);
      let user_type_id = user_type_arr.user_type_id;

      if (user_type_id == 1) {
        this.my_appointment = true;
      }

      let a;
      for (a = 0; a < access_right.length; a++) {
        if (access_right[a] == "1001") {
          this.dashboard = true;
        }
        if (access_right[a] == "1002") {
          this.polyclinic = true;
        }
        if (access_right[a] == "1003") {
          this.my_appointment = true;
        }
        if (access_right[a] == "1004") {
          this.eksekutif_dashboard = true;
        }
        if (access_right[a] == "2001") {
          this.titleDoctorPatient = true;
          this.doctor = true;
          this.doctor_list = true;
        }
        if (access_right[a] == "2003") {
          this.titleDoctorPatient = true;
          this.doctor = true;
          this.doctor_treatment = true;
        }
        if (access_right[a] == "3001") {
          this.titleMarketing = true;
          this.marketing_crm = true;
          this.patient = true;
          this.patient_list = true;
        }
        if (access_right[a] == "3005") {
          this.titleDoctorPatient = true;
          this.patient = true;
          this.patient_case = true;
          this.patient_case_print = true;
        }
        if (access_right[a] == "3007") {
          this.titleDoctorPatient = true;
          this.patient = true;
          this.patient_document = true;
        }
        if (access_right[a] == "4001") {
          this.titleDoctorPatient = true;
          this.schedule = true;
          this.schedule_list = true;
        }
        if (access_right[a] == "4001") {
          this.titleDoctorPatient = true;
          this.schedule = true;
          this.schedule_holiday = true;
        }
        if (access_right[a] == "5001") {
          this.titleDoctorPatient = true;
          this.appointment = true;
          this.appointment_list = true;
          this.appointment_today = true;
          this.appointment_upcoming = true;
          this.appointment_calendar = true;
        }
        if (access_right[a] == "5002") {
          this.titleDoctorPatient = true;
          this.appointment = true;
          this.appointment_add = true;
        }
        if (access_right[a] == "10101") {
          this.titleDoctorPatient = true;
          this.clinic_queue = true;
          this.clinic_queue_dashboard = true;
        }
        if (access_right[a] == "10102") {
          this.titleDoctorPatient = true;
          this.clinic_queue = true;
          this.clinic_queue_display = true;
        }
        if (access_right[a] == "10103") {
          this.titleDoctorPatient = true;
          this.clinic_queue = true;
          this.clinic_queue_settings = true;
        }
        if (access_right[a] == "10104") {
          this.titleDoctorPatient = true;
          this.clinic_queue = true;
          this.clinic_queue_report = true;
        }
        if (["10601", "10602", "10603", "10604", "10605"].includes(String(access_right[a]))) {
          this.titleDoctorPatient = true;
          this.home_care = true;
        }
        if (access_right[a] == "10602") this.home_care_manage = true;
        if (access_right[a] == "10603") this.home_care_clinical = true;
        if (access_right[a] == "10604") this.home_care_report = true;
        if (access_right[a] == "10605") this.home_care_settings = true;
        if (access_right[a] == "10201" || access_right[a] == "10202" || access_right[a] == "10203") {
          this.titleDoctorPatient = true;
          this.quality = true;
        }
        if (access_right[a] == "10301" || access_right[a] == "10302" || access_right[a] == "10303") {
          this.titleDoctorPatient = true;
          this.clinical_documents = true;
        }
        if (access_right[a] == "10401") {
          this.titleDoctorPatient = true;
          this.bpjs = true;
        }
        if (access_right[a] == "10402") {
          this.titleDoctorPatient = true;
          this.bpjs = true;
          this.bpjs_settings = true;
        }
        if (["10501", "10502", "10503", "10504"].includes(String(access_right[a]))) {
          this.titlePaymentHumanResource = true;
          this.payment = true;
          this.guarantor = true;
        }
        if (access_right[a] == "6001") {
          this.titlePaymentHumanResource = true;
          this.payment = true;
          this.payment_list = true;
        }
        if (access_right[a] == "6002") {
          this.titlePaymentHumanResource = true;
          this.payment = true;
          this.payment_add = true;
        }
        if (access_right[a] == "6003") {
          this.payment = true;
          this.payment_category = true;
        }
        if (access_right[a] == "6004") {
          this.titlePaymentHumanResource = true;
          this.payment = true;
          this.expense_list = true;
        }
        if (access_right[a] == "6005") {
          this.titlePaymentHumanResource = true;
          this.payment = true;
          this.expense_add = true;
        }
        if (access_right[a] == "6006") {
          this.titlePaymentHumanResource = true;
          this.payment = true;
          this.expense_category = true;
        }
        if (access_right[a] == "6008") {
          this.titlePaymentHumanResource = true;
          this.payment = true;
          this.coa = true;
        }
        if (access_right[a] == "6001") {
          this.titlePaymentHumanResource = true;
          this.payment = true;
          this.payment_list = true;
        }
        if (access_right[a] == "6021") {
          this.titlePaymentHumanResource = true;
          this.payment = true;
          this.payment_po = true;
        }
        if (access_right[a] == "7001") {
          this.titlePaymentHumanResource = true;
          this.human_resource = true;
          this.human_resource_employee = true;
        }
        if (access_right[a] == "7003") {
          this.titlePaymentHumanResource = true;
          this.human_resource = true;
          this.payroll_list = true;
        }
        if (access_right[a] == "7005") {
          this.titlePaymentHumanResource = true;
          this.human_resource = true;
          this.remuneration = true;
        }
        if (access_right[a] == "8001") {
          this.titleDoctorPatient = true;
          this.prescription = true;
        }
        if (access_right[a] == "9001") {
          this.titlePharmacy = true;
          this.medicine = true;
          this.medicine_list = true;
        }
        if (access_right[a] == "9002") {
          this.titlePharmacy = true;
          this.medicine = true;
          this.medicine_add = true;
        }
        if (access_right[a] == "9003") {
          this.titlePharmacy = true;
          this.medicine = true;
          this.medicine_category = true;
        }
        if (access_right[a] == "9004") {
          this.titlePharmacy = true;
          this.medicine = true;
          this.medicine_stock = true;
        }
        if (access_right[a] == "9006") {
          this.titlePharmacy = true;
          this.medicine = true;
          this.medicine_vendor = true;
        }
        if (access_right[a] == "9008") {
          this.titlePharmacy = true;
          this.medicine = true;
          this.stock_opname = true;
        }
        if (access_right[a] == "9009") {
          this.titlePharmacy = true;
          this.medicine = true;
          this.stock_opname = true;
        }
        if (access_right[a] == "1101") {
          this.titleOperational = true;
          this.lab = true;
          this.lab_procedure = true;
        }
        if (access_right[a] == "1103") {
          this.titleOperational = true;
          this.lab = true;
          this.lab_report_list = true;
        }
        if (access_right[a] == "1104") {
          this.titleOperational = true;
          this.lab = true;
          this.lab_report_add = true;
          this.lab_operations = true;
        }
        if (access_right[a] == "1105") {
          this.titleOperational = true;
          this.lab = true;
          this.lab_template = true;
        }
        if (access_right[a] == "1106") {
          this.titleOperational = true;
          this.lab = true;
        }
        if (access_right[a] == "1107") {
          this.titleOperational = true;
          this.lab = true;
          this.lab_operations = true;
        }
        if (access_right[a] == "1108" || access_right[a] == "1109") {
          this.titleOperational = true;
          this.lab = true;
          this.fields = true;
        }
        if (access_right[a] == "1201") {
          this.titleOperational = true;
          this.medical_action = true;
          this.medical_action_list = true;
        }
        if (access_right[a] == "1202") {
          this.titleOperational = true;
          this.medical_action = true;
          this.medical_action_add = true;
        }
        if (access_right[a] == "1203") {
          this.titleOperational = true;
          this.medical_action = true;
          this.master_action_type = true;
        }
        if (access_right[a] == "1301") {
          this.titleOperational = true;
          this.bed = true;
          this.bed_list = true;
        }
        if (access_right[a] == "1302") {
          this.titleOperational = true;
          this.bed = true;
          this.bed_add = true;
        }
        if (access_right[a] == "1304") {
          this.titleOperational = true;
          this.bed = true;
          this.bed_category = true;
        }
        if (access_right[a] == "1305") {
          this.titleOperational = true;
          this.bed = true;
          this.bed_allotment = true;
          this.bed_add_allotment = true;
        }
        if (access_right[a] == "1303") {
          this.titleOperational = true;
          this.bed = true;
          this.bed_allotment = true;
        }
        if (access_right[a] == "1305") {
          this.titleOperational = true;
          this.bed = true;
          this.bed_add_allotment = true;
        }
        if (access_right[a] == "2201") {
          this.titleOperational = true;
          this.blood_bank = true;
          this.donor_list = true;
        }
        if (access_right[a] == "2202") {
          this.titleOperational = true;
          this.blood_bank = true;
          this.donor_add = true;
        }
        if (access_right[a] == "2401") {
          this.titleOperational = true;
          this.blood_bank = true;
          this.donor_recipient = true;
        }
        if (access_right[a] == "2402") {
          this.titleOperational = true;
          this.blood_bank = true;
          this.donor_recipient_add = true;
        }
        if (access_right[a] == "2501") {
          this.titleOperational = true;
          this.blood_bank = true;
          this.blood_bank_list = true;
        }
        if (access_right[a] == "1401") {
          this.titlePharmacy = true;
          this.pharmacy = true;
          this.pharmacy_sales = true;
        }
        if (access_right[a] == "1402") {
          this.titlePharmacy = true;
          this.pharmacy = true;
          this.pharmacy_cashier = true;
        }
        if (access_right[a] == "1408") {
          this.titlePharmacy = true;
          this.pharmacy = true;
          this.pharmacy_compounds = true;
          this.pharmacy_workflow = true;
        }
        if (access_right[a] == "1410") {
          this.titlePharmacy = true;
          this.pharmacy = true;
          this.pharmacy_workflow = true;
        }
        if (access_right[a] == "1409") {
          this.titlePharmacy = true;
          this.pharmacy = true;
          this.pharmacy_workflow = true;
        }
        if (access_right[a] == "1411" || access_right[a] == "9004") {
          this.titlePharmacy = true;
          this.pharmacy = true;
          this.pharmacy_control_center = true;
        }
        if (access_right[a] == "1403") {
          this.titlePharmacy = true;
          this.pharmacy = true;
          this.pharmacy_expense_list = true;
        }
        if (access_right[a] == "1404") {
          this.titlePharmacy = true;
          this.pharmacy = true;
          this.pharmacy_expense_add = true;
        }
        if (access_right[a] == "1405") {
          this.titlePharmacy = true;
          this.pharmacy = true;
          this.pharmacy_expense_category_list = true;
        }
        if (access_right[a] == "1406") {
          this.titlePharmacy = true;
          this.pharmacy = true;
          this.pharmacy_po = true;
        }
        if (access_right[a] == "2301") {
          this.titlePharmacy = true;
          this.announcement = true;
        }
        if (access_right[a] == "1501") {
          this.titleReportAnalysis = true;
          this.report = true;
          this.report_payment_report = true;
        }
        if (access_right[a] == "1502") {
          this.titleReportAnalysis = true;
          this.report = true;
          this.report_doctor_commision = true;
        }
        if (access_right[a] == "1503") {
          this.titleReportAnalysis = true;
          this.report = true;
          this.report_expense_report = true;
        }
        if (access_right[a] == "1504") {
          this.titleReportAnalysis = true;
          this.report = true;
          this.report_pharmacy_report = true;
        }
        if (access_right[a] == "1505") {
          this.titleReportAnalysis = true;
          this.report = true;
          this.report_pharmacy_expense_report = true;
        }
        if (access_right[a] == "1506") {
          this.titleReportAnalysis = true;
          this.report = true;
          this.journal_report_list = true;
        }
        if (access_right[a] == "1507") {
          this.titleReportAnalysis = true;
          this.report = true;
          this.payroll_report_list = true;
        }
        if (access_right[a] == "1508") {
          this.titleReportAnalysis = true;
          this.report = true;
          this.stock_opname_report_list = true;
        }
        if (access_right[a] == "1601") {
          this.system_setting = true;
          this.system = true;
        }
        if (access_right[a] == "1602") {
          this.system_setting = true;
          this.setting_system = true;
        }
        if (access_right[a] == "2601") {
          this.online_shop = true;
          this.system_online_shop = true;
        }

        if (access_right[a] == "1701") {
          this.titleWebsite = true;
          this.setting = true;
          this.cms = true;
          this.website_setting = true;
          this.website_service = true;
          this.website_slide = true;
          this.website_doctor = true;
          this.website_post = true;
          this.website_post_category = true;
        }
        if (access_right[a] == "1801") {
          this.titleMarketing = true;
          this.marketing_view = true;
          this.titleEtc = true;
          this.master = true;
          this.master_lab_category = true;
          this.master_building = true;
          this.master_room = true;
          this.master_payment_method = true;
          this.master_payment_category_type = true;
          this.master_department = true;
          this.master_position = true;
          this.master_remuneration = true;
          this.master_announcement_category = true;
          this.master_announcement = true;
          this.master_coa_category = true;
          this.master_sub_ledger = true;
          this.master_cash_flow = true;
          this.master_appointment_status = true;
          this.master_uom = true;
          this.master_bank_account = true;
          this.master_warehouse = true;
        }
        if (access_right[a] == "1802") {
          this.titleMarketing = true;
          this.marketing_view = true;
          this.titleEtc = true;
          this.master = true;
          this.master_lab_category = true;
          this.master_building = true;
          this.master_room = true;
          this.master_payment_method = true;
          this.master_payment_category_type = true;
          this.master_department = true;
          this.master_position = true;
          this.master_remuneration = true;
          this.master_announcement_category = true;
          this.master_announcement = true;
          this.master_coa_category = true;
          this.master_sub_ledger = true;
          this.master_cash_flow = true;
          this.master_appointment_status = true;
          this.master_uom = true;
          this.master_action_type = true;
          this.master_bank_account = true;
          this.master_warehouse = true;
        }
        if (access_right[a] == "10701" || access_right[a] == "10702") {
          this.titleMarketing = true;
          this.marketing_view = true;
        }
        if (access_right[a] == "1901") {
          this.titleEtc = true;
          this.user_management = true;
          this.user_access = true;
          this.position_access = true;
          this.audit_log = true;
        }
        if (["10801", "10802", "10803", "10804"].includes(String(access_right[a]))) {
          this.branch_network = true;
          this.titleEtc = true;
        }
        if (String(access_right[a]) === "10802") {
          this.vertical_settings = true;
        }
        if (access_right[a] == "1903") {
          this.titleEtc = true;
          this.audit_log = true;
        }
        if (access_right[a] == "2100") {
          this.data_analysis = true;
        }
        if (access_right[a] == "2701") {
          this.shortcut_obat_alkes = true;
        }
        if (access_right[a] == "2800") {
          this.recap_action_report = true;
        }
        if (access_right[a] == "2801") {
          this.recap_action_report_list = true;
        }
        if (access_right[a] == "2802") {
          this.recap_action_report_manipulate = true;
        }
        if (access_right[a] == "2901" || access_right[a] == "2092") {
          this.configuration = true;
        }
        if (access_right[a] == "10001") {
          this.satu_sehat_dashboard = true;
          this.satu_sehat_menu = true;
        }
        if (access_right[a] == "10002") {
          this.satu_sehat_posting = true;
          this.satu_sehat_menu = true;
        }
        if (access_right[a] == "10003") {
          this.satu_sehat_api = true;
          this.satu_sehat_menu = true;
        }
      }

      this.$nextTick(() => this.initializeMenuSections(true));
    },
    hasProductCapability(code) {
      return this.productCapabilityCodes.includes(code);
    },
  },
  mounted() {
    // Refresh effective rights from the tenant/package mapping so restored or
    // newly assigned modules are visible without forcing the user to log out.
    this.getAccessRight();
    this.$root.$on("setMenuActive", () => {
      this.getAccessRight();
    });
    this.$nextTick(() => this.initializeMenuSections());
    this.productConfigurationListener = (event) => {
      this.productConfiguration = event.detail || ProductConfigurationService.current();
    };
    window.addEventListener("medhop:product-configuration", this.productConfigurationListener);
  },
  beforeDestroy() {
    window.removeEventListener("medhop:product-configuration", this.productConfigurationListener);
  },
  watch: {
    "$route.fullPath"() {
      this.$nextTick(() => this.initializeMenuSections());
    },
  },
  computed: {
    ...mapGetters(["currentUserPersonalInfo"]),
    canViewMyAppointment() {
      let storedUser = {};
      try {
        storedUser = JSON.parse(window.localStorage.getItem("user")) || {};
      } catch (error) {
        storedUser = {};
      }

      const user = {
        ...storedUser,
        ...(this.currentUserPersonalInfo || {}),
      };
      const userTypeId = Number(user.user_type_id);
      const roleKey = String(
        user.role_key_name || user.role_key || user.role || ""
      ).toLowerCase().replace(/[\s-]+/g, "_");
      const isDoctor = userTypeId === 1;
      const isSuperAdmin =
        roleKey === "super_admin" ||
        user.is_super_admin === true ||
        user.is_super_admin === 1 ||
        (Number(user.role_id) === 1 && !user.user_type_id);

      return isDoctor || isSuperAdmin;
    },
    helpMenu() {
      return {
        key: "help",
        label: "Bantuan",
        icon: "fas fa-question-circle",
        children: [
          { to: "/guide", label: "Tutorial" },
          { to: "/help", label: "Kontak Dukungan" },
        ],
      };
    },
    reportAnalysisMenus() {
      const menus = [
        {
          key: "report-summary",
          label: "Ringkasan Eksekutif",
          icon: "fas fa-chart-line",
          to: "/report",
          exact: true,
        },
        {
          key: "report-operations",
          label: "Operasional Klinik",
          icon: "fas fa-clinic-medical",
          children: [
            { to: "/report/view/visits", label: "Kunjungan Pasien" },
            { to: "/report/view/queue-performance", label: "Antrean & Waktu Tunggu" },
            { to: "/report/view/doctor-productivity", label: "Produktivitas Dokter" },
          ],
        },
        {
          key: "report-patients",
          label: "Klinis & Pasien",
          icon: "fas fa-notes-medical",
          children: [
            { to: "/report/view/disease-top", label: "10 Besar Penyakit ICD-10" },
            { to: "/report/view/patient-registration", label: "Demografi & Pasien Baru" },
            { to: "/report/view/medical-actions", label: "Tindakan Medis" },
            { to: "/report/view/laboratory", label: "Aktivitas Laboratorium" },
          ],
        },
        {
          key: "report-finance",
          label: "Keuangan",
          icon: "fas fa-coins",
          children: [
            { to: "/report/view/revenue-detail", label: "Pendapatan Klinik" },
            { to: "/report/view/revenue-service", label: "Pendapatan per Layanan" },
            { to: "/report/view/expense-detail", label: "Pengeluaran Klinik" },
            { to: "/report/view/payment-methods", label: "Metode Pembayaran" },
          ],
        },
        {
          key: "report-pharmacy",
          label: "Farmasi & Persediaan",
          icon: "fas fa-pills",
          children: [
            { to: "/report/view/pharmacy-sales", label: "Penjualan Apotek" },
            { to: "/report/view/medicine-sales", label: "Penjualan per Obat" },
            { to: "/report/view/stock-position", label: "Posisi Stok & Batch" },
            { to: "/report/view/stock-movements", label: "Kartu & Pergerakan Stok" },
          ],
        },
        {
          key: "report-workforce",
          label: "SDM & Remunerasi",
          icon: "fas fa-user-tie",
          children: [
            { to: "/report/view/attendance", label: "Kehadiran Pegawai" },
            { to: "/report/view/doctor-commission", label: "Komisi Dokter" },
          ],
        },
        {
          key: "report-quality",
          label: "Mutu & Kepatuhan",
          icon: "fas fa-shield-alt",
          children: [
            { to: "/report/view/quality-indicators", label: "Indikator Mutu" },
            { to: "/report/view/safety-incidents", label: "Keselamatan Pasien" },
            { to: "/report/view/bpjs-integration", label: "Integrasi BPJS" },
          ],
        },
        this.home_care_report && {
          key: "report-home-care",
          label: "Home Care",
          icon: "fas fa-house-user",
          to: "/home-care?tab=reports",
          exact: true,
        },
        {
          key: "report-library",
          label: "Pustaka Laporan",
          icon: "fas fa-folder-open",
          to: "/report/library",
          exact: true,
        },
      ];

      return menus.filter((item) => !item.children || item.children.length);
    },
    patientServiceMenus() {
      return [
        this.clinic_queue && {
          key: "queue",
          label: "Antrean Klinik",
          icon: "fas fa-ticket-alt",
          children: [
            this.clinic_queue_dashboard && { to: "/queue", label: "Dashboard Antrean" },
            this.clinic_queue_display && { to: "/queue/display", label: "Display Antrean" },
            this.clinic_queue_settings && { to: "/queue/settings", label: "Pengaturan Loket" },
            this.clinic_queue_report && { to: "/queue/report", label: "Laporan Antrean" },
          ].filter(Boolean),
        },
        this.appointment && {
          key: "appointment",
          label: "Pendaftaran & Janji",
          icon: "fas fa-clipboard-list",
          children: [
            this.appointment_list && { to: "/appointment/list/0", label: "Semua Pendaftaran" },
            this.appointment_add && { to: "/appointment/add", label: "Pendaftaran Baru" },
            this.appointment_today && { to: "/appointment/todays", label: "Hari Ini" },
            this.appointment_upcoming && { to: "/appointment/upcoming", label: "Akan Datang" },
            this.appointment_calendar && { to: "/appointment/calendar", label: "Kalender Janji" },
            this.appointment_calendar && { to: "/appointment/room-calendar", label: "Kalender Ruangan" },
            this.master_appointment_status && { to: "/masters/appointment-statuses/list", label: "Status Janji" },
          ].filter(Boolean),
        },
        this.bed && {
          key: "inpatient",
          label: "Rawat Inap",
          icon: "fas fa-hospital-user",
          to: "/inpatient",
        },
        this.verticalClinicalMenus.length && {
          key: "vertical-clinical",
          label: "Layanan Spesialis",
          icon: "fas fa-clinic-medical",
          children: this.verticalClinicalMenus,
        },
        this.home_care && {
          key: "home-care",
          label: "Home Care",
          icon: "fas fa-house-user",
          to: "/home-care",
        },
        this.patient && {
          key: "patient",
          label: "Pasien",
          icon: "fas fa-user-injured",
          children: [
            this.patient_list && { to: "/patient/list", label: "Data Pasien" },
            this.patient_case && { to: "/patient/cases", label: "Rekam Medis" },
            this.patient_case_print && { to: "/patient/themplate-print", label: "Cetak Blanko Rekam Medis" },
            this.patient_document && { to: "/patient/documents", label: "Dokumen Pasien" },
            this.prescription && { to: "/prescriptions/list", label: "Resep Pasien" },
          ].filter(Boolean),
        },
        (this.doctor || this.schedule) && {
          key: "doctor",
          label: "Dokter",
          icon: "fas fa-user-md",
          children: [
            this.doctor_list && { to: "/doctor/list", label: "Data Dokter" },
            (this.schedule_list || this.schedule_holiday) && {
              to: "/schedule/list",
              label: "Jadwal Praktek & Libur",
            },
            this.doctor_treatment && { to: "/doctor/treatments", label: "Riwayat Pengobatan" },
          ].filter(Boolean),
        },
        this.bpjs && {
          key: "bpjs",
          label: "BPJS",
          icon: "fas fa-id-card",
          children: this.bpjsMenus.filter(item => item.to !== "/bpjs/pengaturan" || this.bpjs_settings).map((item) => ({
            to: item.to,
            label: item.label,
          })),
        },
        this.quality && {
          key: "quality",
          label: "Mutu & Keselamatan",
          icon: "fas fa-shield-alt",
          to: "/quality",
        },
        this.clinical_documents && {
          key: "clinical-documents",
          label: "Consent & Dokumen Klinis",
          icon: "fas fa-file-signature",
          to: "/clinical-documents",
        },
      ].filter(Boolean);
    },
    productCapabilityCodes() {
      return (this.productConfiguration.capabilities || []).map(item => item.code || item);
    },
    verticalClinicalMenus() {
      return [
        this.hasProductCapability("dental.odontogram") && { to: "/dental", label: "Klinik Gigi" },
        this.hasProductCapability("aesthetic.before_after") && { to: "/vertical-clinical/aesthetic_before_after", label: "Klinik Kecantikan" },
        this.hasProductCapability("maternal.antenatal") && { to: "/vertical-clinical/maternal_antenatal", label: "Klinik Ibu & Anak" },
        this.hasProductCapability("mcu.fit_conclusion") && { to: "/vertical-clinical/mcu_conclusion", label: "Medical Check Up" },
        this.hasProductCapability("eye.visual_acuity") && { to: "/vertical-clinical/eye_visual_acuity", label: "Klinik Mata" },
        this.hasProductCapability("physio.case_management") && { to: "/therapy", label: "Klinik Therapy" },
        !this.hasProductCapability("physio.case_management") && this.hasProductCapability("physio.assessment") && { to: "/vertical-clinical/physio_assessment", label: "Fisioterapi" },
        this.hasProductCapability("occupational.hazard_profile") && { to: "/vertical-clinical/occupational_hazard", label: "Kesehatan Kerja" },
        this.hasProductCapability("vaccination.dose_management") && { to: "/vertical-clinical/vaccination_dose", label: "Vaksinasi" },
      ].filter(Boolean);
    },
  },
};
</script>

<style scoped>
.menu-nav--compact > .menu-section {
  align-items: center;
  cursor: pointer;
  display: flex;
  min-height: 38px;
  outline: none;
  padding-right: 18px;
  transition: background-color 0.15s ease;
}

.menu-nav--compact > .menu-section:hover,
.menu-nav--compact > .menu-section:focus-visible {
  background: rgba(54, 153, 255, 0.08);
}

.menu-nav--compact > .menu-section::after {
  color: #7e8299;
  content: "\f054";
  font-family: "Font Awesome 5 Free";
  font-size: 10px;
  font-weight: 900;
  margin-left: auto;
  transition: transform 0.15s ease;
}

.menu-nav--compact > .menu-section.menu-section-open::after {
  transform: rotate(90deg);
}

.menu-nav--compact > [hidden] {
  display: none !important;
}

.trust-center-menu-item {
  margin-top: 8px;
  border-top: 1px solid rgba(126, 130, 153, 0.16);
  padding-top: 8px;
}
</style>
